import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../components/form/CheckboxInput'

const CheckInSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  return (
    <CheckboxInput
      label={t('fieldsStep.requireCheckin')}
      value={form.requireCheckin}
      onChange={value => handleChange('requireCheckin', value)}
      {...commonProps}
    />
  )
}

export default CheckInSection
